export const siteConfig = {
  title: "MagnifyBI - Bring Your Shopify Store Data to the Big Screen",
  description:
    "Give your team instant visibility into Shopify sales, orders, and more with MagnifyBI. Display live wallboard dashboards on any big screen.",
  siteUrl: "https://magnifybi.com",
  appStoreUrl: "https://apps.shopify.com/magnify",
  socialBanner: "/landing/static/images/office-preview.png",
  author: "MagnifyBI",
  language: "en",
  locale: "en-GB",
};
